import css from "./sidebar.module.scss";
import { TenantAvatar } from "../TenantAvatar";

interface SidebarButtonProps {
  icon?: string | null;
  label: string;
  onClick: () => void;
  active?: boolean;
  isAvatar?: boolean;
  hasBorder?: boolean;
  isExpanded?: boolean;
  disabled?: boolean;
  "data-testid"?: string;
}

export function SidebarButton({
  icon,
  label,
  onClick,
  active = false,
  isAvatar = false,
  hasBorder = false,
  isExpanded = false,
  disabled = false,
  "data-testid": testId,
}: SidebarButtonProps) {
  const classes = [
    css.button,
    isExpanded ? css.buttonExpanded : "",
    hasBorder ? css.buttonWithBorder : "",
    disabled ? css.buttonDisabled : "",
    active ? "active" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={css.navItemWrapper}>
      <button
        className={classes}
        onClick={onClick}
        aria-label={label}
        aria-disabled={disabled}
        disabled={disabled}
        data-testid={testId}
      >
        <span className={css.iconWrapper}>
          {isAvatar ? (
            <TenantAvatar
              logoUrl={icon}
              name={label}
              size={36}
              circle
              className={css.avatarIcon}
            />
          ) : (
            <img src={icon ?? ""} alt="" role="img" className={css.icon} />
          )}
        </span>
        <span className={isExpanded ? css.labelVisible : css.label}>{label}</span>
      </button>
      {!isExpanded && (
        <span className={css.tooltip} aria-hidden="true" data-testid="sidebar-tooltip">
          {label}
        </span>
      )}
    </div>
  );
}
